export const FETCHING = "HOME/FETCHING";
export const SUCCESS = "HOME/SUCCESS";
export const ERROR = "HOME/ERROR";
export const ACTIVE_CAMPAIGN = "HOME/ACTIVE_CAMPAIGN"
